'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = require('./components/Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

var _NoCollapse = require('./components/NoCollapse');

var _NoCollapse2 = _interopRequireDefault(_NoCollapse);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridItemCTA = function GridItemCTA(_ref) {
  var _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === undefined ? '' : _ref$imgSrc,
      title = _ref.title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === undefined ? '' : _ref$subtitle,
      _ref$links = _ref.links,
      links = _ref$links === undefined ? [] : _ref$links,
      buttonLabel = _ref.buttonLabel,
      buttonUrl = _ref.buttonUrl,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === undefined ? true : _ref$collapse,
      gridEvenOdd = _ref.gridEvenOdd,
      superSize = _ref.superSize;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $gridEvenOdd: gridEvenOdd,
      $superSize: superSize
    },
    _react2.default.createElement(_NoCollapse2.default, {
      imgSrc: imgSrc,
      title: title,
      subtitle: subtitle,
      links: links,
      buttonLabel: buttonLabel,
      buttonUrl: buttonUrl,
      collapse: collapse
    }),
    _react2.default.createElement(_Collapse2.default, {
      title: title,
      buttonUrl: buttonUrl,
      collapse: collapse,
      links: links
    })
  );
};

GridItemCTA.propTypes = {
  imgSrc: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string,
  links: _propTypes2.default.arrayOf(Object),
  buttonLabel: _propTypes2.default.string.isRequired,
  buttonUrl: _propTypes2.default.string.isRequired,
  collapse: _propTypes2.default.bool,
  gridEvenOdd: _propTypes2.default.oneOf(['even', 'odd']).isRequired,
  superSize: _propTypes2.default.bool.isRequired
};

GridItemCTA.displayName = 'GridItemCTA';

exports.default = GridItemCTA;
GridItemCTA.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'GridItemCTA',
  'props': {
    'imgSrc': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'subtitle': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'links': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': 'Object'
        }
      },
      'required': false,
      'description': ''
    },
    'collapse': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'buttonLabel': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'buttonUrl': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'gridEvenOdd': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'even\'',
          'computed': false
        }, {
          'value': '\'odd\'',
          'computed': false
        }]
      },
      'required': true,
      'description': ''
    },
    'superSize': {
      'type': {
        'name': 'bool'
      },
      'required': true,
      'description': ''
    }
  }
};